export default function LookupColumnValidator(values) {
  if (!values.options.source_column_id) {
    window.appStore.notificationStore.showNotification(
      "Please select Lookup Column",
      "error"
    );
    return false;
  }
  return true;
}
